import React, { useState } from 'react';
import axios from 'axios';
import { env } from '../config';
import LegacyBlock from '../components/LegacyBlock';
import ContactUs from '../images/contact-us.webp';

const Contact = () => {
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        email: '',
        message: '',
    });
    const [status, setStatus] = useState({ type: '', message: '' });
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const firstName = formData.firstName.trim();
        const email = formData.email.trim();
        const message = formData.message.trim();

        if (!firstName) {
            setStatus({ type: 'error', message: 'Please enter your first name.' });
            return;
        }

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!email || !emailRegex.test(email)) {
            setStatus({ type: 'error', message: 'Please enter a valid email address.' });
            return;
        }

        if (!message) {
            setStatus({ type: 'error', message: 'Please enter your message.' });
            return;
        }

        setLoading(true);
        setStatus({ type: '', message: '' });

        try {
            const response = await axios.post(`${env.baseUrl}/api/contact`, {
                first_name: firstName,
                last_name: formData.lastName.trim(),
                email: email,
                message: message,
            });

            setStatus({
                type: 'success',
                message: response.data?.message || 'Thank you! Your message has been sent successfully.',
            });
            setFormData({
                firstName: '',
                lastName: '',
                email: '',
                message: '',
            });
        } catch (error) {
            const errorMsg =
                error?.response?.data?.errors?.message?.[0] ||
                error?.response?.data?.errors?.email?.[0] ||
                error?.response?.data?.errors?.first_name?.[0] ||
                error?.response?.data?.message ||
                'Something went wrong. Please try again later.';
            setStatus({ type: 'error', message: errorMsg });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <section className="inner-banner">
                <div className="container">
                    <div className="text-block">
                        <h3><em>Contact</em></h3>
                        <h1><em>Yalla Lebanon</em></h1>
                    </div>
                </div>
            </section>
            <section className="about-us">
                <div className="container">
                    <div className="title-block text-center">
                        <h2>Get in Touch</h2>
                        <p>Have a question or feedback? Reach out to us and we will be happy to assist you.</p>
                    </div>
                    <div className="contact-sec">
                        <div className="row">
                            <div className="col-lg-6 col-md-12">
                                <div className="lt-block">
                                    <div className="img-block position-relative">
                                        <img src={ContactUs} alt="Contact Us" />
                                    </div>
                                    <h3>Contact Us</h3>
                                    <ul>
                                        <li>
                                            <h4>Phone</h4>
                                            <p><a href="tel:+34674811645">+34674811645</a></p>
                                        </li>
                                        <li>
                                            <h4>Email</h4>
                                            <p><a href="mailto:faoualabi@gmail.com">faoualabi@gmail.com</a></p>
                                        </li>
                                        <li>
                                            <h4>Address</h4>
                                            <p>98 carrer marina 08018 barcelona </p>
                                        </li>
                                        <li>
                                            <h4>Follow Us </h4>
                                            <div className="socila">
                                                <a href="https://www.facebook.com/YallaLebanondotcom/" target="_blank" rel="noopener noreferrer" aria-label="Facebook"><i className="fa-brands fa-facebook-f" /></a>
                                                <a href="https://www.instagram.com/yallalebanon_com/" target="_blank" rel="noopener noreferrer" aria-label="Instagram"><i className="fa-brands fa-instagram" /></a>
                                                <a href="https://x.com/yallalebanon" target="_blank" rel="noopener noreferrer" aria-label="X (Twitter)"><i className="fa-brands fa-x-twitter" /></a>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-12">
                                <div className="rt-block">
                                    <h3>Send a Message</h3>
                                    <form onSubmit={handleSubmit}>
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <p>First Name <span className="text-danger">*</span></p>
                                                    <input 
                                                        className="form-control" 
                                                        type="text" 
                                                        placeholder="First Name" 
                                                        name="firstName" 
                                                        value={formData.firstName}
                                                        onChange={handleChange}
                                                        required 
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <p>Last Name</p>
                                                    <input 
                                                        className="form-control" 
                                                        type="text" 
                                                        placeholder="Last Name" 
                                                        name="lastName" 
                                                        value={formData.lastName}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <p>Email Address <span className="text-danger">*</span></p>
                                                    <input 
                                                        className="form-control" 
                                                        type="email" 
                                                        placeholder="Email Address" 
                                                        name="email" 
                                                        value={formData.email}
                                                        onChange={handleChange}
                                                        required 
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <p>Message <span className="text-danger">*</span></p>
                                                    <textarea 
                                                        className="form-control" 
                                                        placeholder="Message" 
                                                        name="message" 
                                                        value={formData.message}
                                                        onChange={handleChange}
                                                        rows={5}
                                                        required 
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="btn">
                                            <button 
                                                className="button-submit" 
                                                type="submit" 
                                                disabled={loading}
                                                style={{ cursor: loading ? 'not-allowed' : 'pointer' }}
                                            >
                                                {loading ? 'Sending...' : 'Submit'}
                                            </button>
                                        </div>
                                        {status.message && (
                                            <div 
                                                className={`alert ${status.type === 'error' ? 'alert-danger' : 'alert-success'}`}
                                                style={{ marginTop: '15px', padding: '10px 15px', borderRadius: '8px' }}
                                            >
                                                {status.message}
                                            </div>
                                        )}
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <LegacyBlock />
        </div>
    );
};

export default Contact;
